// TODO: Clean up
// import { Resource } from './lib/Resource';
import { Resource2 } from './lib/Resource2';
export * from './lib/components';
export * from './lib/hooks';
// export default Resource;
export default Resource2;
